import React from "react";
import { Link } from "react-router-dom";

import desktopFlow from "../../images/applied-intelligence-flow-desktop.svg";
import mobileFlow from "../../images/applied-intelligence-flow-mobile.svg";
import luminousBackground from "../../images/applied-intelligence-luminous-background.svg";

import "./AppliedIntelligenceSection.css";

function ArrowRight({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 12h14" />
      <path d="m13 6 6 6-6 6" />
    </svg>
  );
}

export default function AppliedIntelligenceSection() {
  return (
    <section
      id="contact"
      className="applied-intelligence-section"
      aria-labelledby="applied-intelligence-title"
    >
      <img
        className="applied-intelligence-section__background"
        src={luminousBackground}
        alt=""
        aria-hidden="true"
      />

      <span
        className="applied-intelligence-section__accent-dot"
        aria-hidden="true"
      />

      <div className="applied-intelligence-section__inner">
        <div className="applied-intelligence-section__copy">
          <p className="applied-intelligence-section__eyebrow">
            Custom Intelligent System Development
          </p>

          <h2
            id="applied-intelligence-title"
            className="applied-intelligence-section__title"
          >
            Turn operational friction into intelligent flow.
          </h2>

          <p className="applied-intelligence-section__body">
            We find where work stalls, decisions slow down or data gets
            lost—then build the intelligent system that connects the
            process and moves the business forward.
          </p>

          <Link
            className="applied-intelligence-section__cta"
            to="/custom-systems"
            aria-label="Tell us about your operational bottleneck"
          >
            <span>Show us the bottleneck</span>
            <ArrowRight />
          </Link>
        </div>

        <div className="applied-intelligence-section__visual">
          <picture className="applied-intelligence-section__picture">
            <source
              media="(max-width: 699px)"
              srcSet={mobileFlow}
            />

            <img
              className="applied-intelligence-section__flow"
              src={desktopFlow}
              alt="People, data and systems connected through applied intelligence to create better operational flow"
              loading="lazy"
            />
          </picture>
        </div>
      </div>
    </section>
  );
}